<template>
  <div class="expand-detail">
    <div class='table-content atb-flex atb-flex-column'>
      <vxe-table
        class='atb-table header-table edit-table'
        border='outer' max-height="400px" auto-resize resizable 
        :data="tableData"
        :show-header="isShowHeader"
        @cell-click="expandRow" ref="tableEl"
      >
        <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
        <vxe-table-column
          width="120"
          field="titleCol"
          title="标题"
        >
        </vxe-table-column>
        <vxe-table-column field="resWkName" title="指定人" width="140">
          <template #default="{ row }">
            <span>{{ row.resWkName }}({{ row.resWkNo }})</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="100"
          field="completeStatus"
          title="完成情况"
          key="month-completeStatus"
          v-if="dataType === 'month'"
        >
          <template #default="{row}">
            <el-tag v-if="row.completeStatus == 10 || row.completeStatus == 0" type="complete" effect="dark">未完成</el-tag>
            <el-tag v-if="row.completeStatus == 20" type="complete" effect="dark">月目标完成</el-tag>
            <el-tag v-if="row.completeStatus == 25" type="complete" effect="dark">总目标完成</el-tag>
            <el-tag v-if="row.completeStatus == 30" type="complete" effect="dark">延迟</el-tag>
            <el-tag v-if="row.completeStatus == 40" type="complete" effect="dark">转移</el-tag>
            <el-tag v-if="row.completeStatus == 50" type="complete" effect="dark">关闭</el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="120"
          field="status"
          title="提交状态"
          v-if="dataType === 'year'"
          key="year-status"
        >
          <template #default="{row}">
            <el-tag
              :type="[30, 50, 70].includes(row.status) ? 'close' : 'complete'"
              effect="dark">
              {{getYearStatusName(row.status)}}
            </el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="160"
          field="reason" title="总结"
          v-if="dataType === 'month'"
        >
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="160"
          field="firstHalfSummary"
          title="上半年总结"
          v-if="dataType === 'year'"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.firstHalfSummary }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="160"
          field="fullSummary"
          title="全年总结"
          v-if="dataType === 'year'"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.fullSummary }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="workItemContent"
          title="工作项目"
        >
          <template #default="scope">
            <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="180"
          field="wholeTarget"
          title="总目标"
          v-if="dataType === 'month'"
        >
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="140"
          field="finishDate"
          title="总目标完成时间"
          v-if="dataType === 'month'"
        >
          <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          width="140"
          field="currentMonthTarget"
          title="本月需达到的目标"
          v-if="dataType === 'month'"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.currentMonthTarget }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="140"
          field="currentMonthFinishDate"
          title="本月目标完成时间"
          v-if="dataType === 'month'"
        >
          <template #default="{ row }">{{ formatDate(row.currentMonthFinishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>

        
        <vxe-table-column
          width="160"
          field="firstHalfTarget"
          title="上半年目标"
          v-if="dataType === 'year'"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.firstHalfTarget }}</div>
          </template>
        </vxe-table-column>
        
        <vxe-table-column
          width="160"
          field="fullTarget"
          title="全年目标"
          v-if="dataType === 'year'"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.fullTarget }}</div>
          </template>
        </vxe-table-column>
        
        <vxe-table-column
          width="150"
          field="startDate"
          title="开始日期"
          v-if="dataType === 'year'"
        >
          <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="finishDate"
          title="最终完成日期"
          v-if="dataType === 'year'"
        >
          <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
export default {
  name: 'ExpandTable',
  props: {
    detailData: {
      type: Array,
      default: () => ([])
    },
    yearCompleteList: {
      type: Array,
      default: () => ([])
    },
    dataType: {
      type: String,
      default: 'year'
    },
    itemType: {
      type: String,
      default: 'year'
    },
  },
  data() {
    return {
      tableData: [],
    }
  },
  computed: {
    isShowHeader() {
      return this.itemType !== this.dataType;
    }
  },
  mounted(){
    const detailData = XEUtils.clone(this.detailData, true);
    const tableData = [];
    if (detailData && detailData.length > 0) {
      detailData.forEach(item => {
        tableData.push({
          ...item.d,
          titleCol: item.title
        })
      })
    }
    this.tableData = tableData;
  },
  methods:{
    expandRow({row, rowIndex}) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.tableEl.updateData(this.tableData);
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    getYearStatusName(val) {
      const obj = this.yearCompleteList.find(t => t.itemValue == val);
      return obj ? obj.itemDesc : '';
    },
  },
  
}
</script>
<style scoped lang='scss'>
  .expand-detail {
    box-shadow: 0px 0px 1px 0px #707070;
    .table-content {
    }
    ::v-deep {
      .vxe-table--main-wrapper {
        box-shadow: 2px 2px 4px 4px inner;
      }
      .vxe-header--row .vxe-header--column {
        background-image: none;
      }
      .vxe-table--header-wrapper.body--wrapper {
        background-color: #fbfbfb!important;
      }
      .vxe-table--body {
        background-color: #fff;
      }
    }
  }
</style>